import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {StatisticState, GroupFilterParams, DetailFilterParams} from './types';

export const actions: ActionTree<StatisticState, RootState> = {
  async getMNStatisticDetail({commit, dispatch}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/mail_notify',
        params: data,
      })
      let messages = resp.data?.messages ?? []
      if (data.page_number > 1) {
        commit('pushMNStatisticDetail', messages);
      } else {
        commit('setMNStatisticDetail', messages);
      }
      return resp;
    } catch(err) {
      throw err;
    }
  },
  async exportMNStatisticDetail({commit, dispatch}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/mail_notify/export',
        params: data,
      });
      return resp;
    } catch(err) {
      throw err;
    }
  },
  async getMNStatisticDetailInfo({ commit, dispatch }, id: string) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/mail_notify/" + id.replace(/#/g, "%23"),
      });
      return resp;
    } catch(err) {
      throw err;
    }
  },
  async getMNStatisticGroup({commit, dispatch}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/mail_notify',
        params: data,
      })
      commit('setMNStatisticGroup', resp.data);
      return resp;
    } catch(err) {
      throw err;
    }
  },
  async exportMNStatisticGroup({commit, dispatch}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/mail_notify/export',
        params: data,
      })
      return resp;
    } catch(err) {
      throw err;
    }
  },
};
